import { useMutation, useQueryClient } from '@tanstack/react-query';
import { homeownerQuotesService } from '@/services/quotes/homeowner';
import type { CalculateQuotePayload } from '@/services/quotes/types';
import { clearClonedQuoteDraftMark } from '@/shared/utils/clone-quote-status.util';

export function useCalculateQuote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CalculateQuotePayload) => {
      const response = await homeownerQuotesService.calculateQuote(payload);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao calcular cotação');
      }

      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['calculateQuote', variables.policyId], data);
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.policyId],
      });
      clearClonedQuoteDraftMark(variables.policyId);
    },
  });
}
